import { useQuery } from '@tanstack/react-query';
import { Interval } from 'luxon';

import { getCampaignsPerformanceForEntity } from 'apis/merchant-gateway/insights/campaigns-performance/api';

import { DateRange } from '../types';

export const useCampaignPerformance = ({
  entityType,
  entityId,
  dateRange,
  enabled = true,
}: {
  entityType: 'venue' | 'merchant';
  entityId: string;
  dateRange: DateRange;
  enabled?: boolean;
}) => {
  const { data, isError, isInitialLoading, isFetching } = useQuery(
    ['insights/campaigns-performance', entityType, entityId, dateRange.from, dateRange.to],
    () => {
      return getCampaignsPerformanceForEntity(
        entityType,
        entityId,
        Interval.fromDateTimes(dateRange.from, dateRange.to),
      );
    },
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!entityId && enabled,
      keepPreviousData: true, // this makes isInitialLoading to return true only on the first load
    },
  );

  return { isError, isInitialLoading, isFetching, campaignPerformance: data?.data?.campaignPerformance?.total };
};
